import * as actionTypes from '../actions/actionTypes';

const initialState = {
    error: null,
    loginInProgressSendSMS: false,
    userId: null,
    token: null,
    firstTimeSignIn: true,
    sendSMS: null,
    loginInProgressVerifyCode: false,
    loginInProgressVerifySMS: false,
    telephone: null,
    isVerified: null,
};

const verifyReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.SMS_START:
            return {
                ...state,
                error: null,
                loginInProgressSendSMS: true,
                telephone: action.telephone,
            };
        case actionTypes.SMS_SUCCESS:
            return {
                ...state,
                error: null,
                sendSMS: true,
                loginInProgressSendSMS: false,
                userId: action.userId,
                token: action.token
            };
        case actionTypes.SMS_FAIL:
            return {
                ...state,
                error: action.error,
                loginInProgressSendSMS: false,
                sendSMS: false,
            };
        case actionTypes.VERIFY_START:
            return {
                ...state,
                loginInProgressVerifySMS: true,
            };
        case actionTypes.VERIFY_SUCCESS:
            return {
                ...state,
                loginInProgressVerifySMS: false,
                isVerified: true,
            };
        case actionTypes.VERIFY_FAIL:
            return {
                ...state,
                loginInProgressVerifySMS: false,
                error: action.error,
                isVerified: false,
            };
        case actionTypes.UPDATE_USER_INFO_SUCCESS:
            return {
                ...state,
                telephone: action.payload.telephone ? action.payload.telephone : state.telephone,
            };
        default:
            return state;
    }

};

export default verifyReducer;